import cn from "classnames"

import { Badge } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./ConfigurationBadge.module.scss"

import type { ConfigurationBadgeProps } from "./ConfigurationBadge.types"

export const ConfigurationBadge = (props: ConfigurationBadgeProps) => {
  const { t } = useTranslation()
  const { type, text = t(`components.configurationBadge.${type}`) } = props
  const isSmallText = props.textSize === "sm"

  return (
    <Badge
      color={type}
      text={props.dot ? undefined : text}
      className={cn(styles.container, styles[type], {
        [styles.containerSm]: isSmallText,
        [styles.textSm]: isSmallText,
        [styles.textSecondary]: props.textColor === "secondary"
      })}
    />
  )
}
